import React, { useEffect, useCallback } from 'react';
import ProductionCalendar from './ProductionCalendar';
import './ProductionCalendarModal.css';

const ProductionCalendarModal = ({ isOpen, onClose }) => {
  // Обработка клавиши Escape
  const handleEscape = useCallback((e) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    if (isOpen) {
      // Добавляем обработчик при открытии
      window.addEventListener('keydown', handleEscape, true);
      
      // Предотвращаем прокрутку body
      document.body.style.overflow = 'hidden';
    }
    
    return () => {
      // Убираем обработчик при закрытии
      window.removeEventListener('keydown', handleEscape, true);
      document.body.style.overflow = '';
    };
  }, [isOpen, handleEscape]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="production-calendar-modal-backdrop" onClick={handleBackdropClick}>
      <div className="production-calendar-modal">
        <div className="production-calendar-modal-header">
          <h2>Производственный календарь РФ</h2>
          <button 
            className="production-calendar-modal-close" 
            onClick={onClose}
            aria-label="Закрыть"
          >
            ×
          </button>
        </div>
        <div className="production-calendar-modal-body">
          <ProductionCalendar />
        </div>
      </div>
    </div>
  );
};

export default ProductionCalendarModal;